import React from 'react';
import { SelectDiaperStrip } from '../SelectDiaperButton/styled';

function OfferStripVarientLive(props) {
  const {
    remainingProductQuantity,
    clickAnimationHandler,
    offerCartData,
    isForNewCdPage,
  } = props;

  return isForNewCdPage ? (
    <div>
      {remainingProductQuantity == 1 ? (
        <SelectDiaperStrip
          onClick={clickAnimationHandler}
          isForNewCdPage={isForNewCdPage}
        >{`Select Your FREE Diaper Pants`}</SelectDiaperStrip>
      ) : remainingProductQuantity == 3 ? (
        <SelectDiaperStrip
          onClick={clickAnimationHandler}
          isForNewCdPage={isForNewCdPage}
        >{`Select Any ${
          remainingProductQuantity - 1
        } Cloth Diapers`}</SelectDiaperStrip>
      ) : remainingProductQuantity > 0 ? (
        <SelectDiaperStrip
          onClick={clickAnimationHandler}
          isForNewCdPage={isForNewCdPage}
        >{`Great Choice! Add ${
          remainingProductQuantity - 1
        } more Cloth diaper`}</SelectDiaperStrip>
      ) : offerCartData?.offerData?.offerName ? (
        <SelectDiaperStrip
          onClick={clickAnimationHandler}
          isForNewCdPage={isForNewCdPage}
        >
          {`B2G1 FREE - Special Diaper Deal Applied`}{' '}
        </SelectDiaperStrip>
      ) : null}
    </div>
  ) : (
    <div>
      {remainingProductQuantity == 1 ? (
        <SelectDiaperStrip
          onClick={clickAnimationHandler}
        >{`Awesome! Now Add Your Free Diaper`}</SelectDiaperStrip>
      ) : remainingProductQuantity == 3 ? (
        <SelectDiaperStrip
          onClick={clickAnimationHandler}
        >{`Select Any ${remainingProductQuantity} Cloth Diapers`}</SelectDiaperStrip>
      ) : remainingProductQuantity > 0 ? (
        <SelectDiaperStrip
          onClick={clickAnimationHandler}
        >{`Great Choice! Add ${remainingProductQuantity} more diapers`}</SelectDiaperStrip>
      ) : offerCartData?.offerData?.offerName ? (
        <SelectDiaperStrip onClick={clickAnimationHandler}>
          {`Congratulations! Buy 2 Get 1 Free Offer Applied!`}{' '}
        </SelectDiaperStrip>
      ) : null}
    </div>
  );
}

export default OfferStripVarientLive;
